import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useSession } from './api/useSession';
import { BootErrorScreen, BootScreen } from './screens/BootScreen';
import { GameScreen } from './screens/GameScreen';
import { TvNavigationProvider } from './tv';

export function App() {
  return (
    <TvNavigationProvider>
      <BrowserRouter>
        <Game />
      </BrowserRouter>
    </TvNavigationProvider>
  );
}

/**
 * Everything that needs a player behind it — which is now everything.
 *
 * The old `/dev` sandbox is gone: with the pet's stats removed there is no
 * simulation left to scrub through, and the editor that replaced it edits the
 * player's *real* home, so it has to sit behind the session like the rest.
 */
function Game() {
  const { session, status, error, retry } = useSession();

  if (status === 'loading') return <BootScreen />;
  if (status === 'error')
    return <BootErrorScreen message={error ?? 'Unknown error'} onRetry={retry} />;
  // `ready` without a session is not a state the bootstrap can produce, but the
  // screen below needs an id rather than a maybe-id, so it is handled honestly.
  if (!session) return <BootErrorScreen message="No session was established." onRetry={retry} />;

  // The identity is threaded down rather than emptied out of the cache on
  // change: the cached pet and world belong to whoever the session says we are,
  // and saying so in the query key is what keeps one player's home from ever
  // being served to another. See `petQueryKey`.
  const userId = session.user.id;

  return (
    <Switch>
      <Route exact path="/pet">
        <GameScreen userId={userId} />
      </Route>
      <Route>
        {/* Including the old /hatch and /dev: neither has anywhere to go now. */}
        <Redirect to="/pet" />
      </Route>
    </Switch>
  );
}
